document.addEventListener('DOMContentLoaded', function () {
  const imageSwiper = document.getElementById('up-feature-compare-image');
  const titleSwiper = document.getElementById('up-feature-compare-title');

  if (imageSwiper && titleSwiper) {
    imageSwiper.addEventListener('swiperslidechange', (event) => {
      const [{ activeIndex }] = event.detail;

      titleSwiper.querySelectorAll('[tab-item]').forEach((item, index) => {
        if (index === activeIndex) {
          item.classList.add('active-tab');
        } else {
          item.classList.remove('active-tab');
        }
      });
    });

    titleSwiper.addEventListener('click', (event) => {
      const target = event.target.closest('[tab-item]');
      if (!target) return;

      const index = target.getAttribute('tab-index');
      if (imageSwiper.swiper) {
        imageSwiper.swiper.slideTo(index);
      }
    });
  }
});